const ShimmerMenu = () => {
  return (
    <div className="shimmermenu-container">
      <div className="menu-title"></div>
      <p className="menu-cuisines"></p>
      <p className="menu-location"></p>
    </div>
  );
};

export default ShimmerMenu;
